import { render, staticRenderFns } from "./edit-doctor.vue?vue&type=template&id=53f51586&"
import script from "./edit-doctor.vue?vue&type=script&lang=js&"
export * from "./edit-doctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports